export const environment = {
  production: false,
  ApiUrl: 'https://user-api-stg-project.alfprod.com/',
  apiCredentials: {
    "UserName": "user@admin",
    "Password": "$yngent@2022"
  },
  snapApiUrl:'https://snap-api-stg-project.alfprod.com/',
  snapapiCredentials: {
    "UserName": "SNAP@admin",
    "Password": "$yngent@2022"
  },
  EBIZApiUrl: 'https://snap-api-stg-project.alfprod.com/api/',
  cloudfrontUrl: 'https://simplstage.syngentasnap.syngentadigitalapps.com/',
  timeoutSec: 90000,
  assetUrl: 'https://assets-stage.syngentaebiz.com/pdf/media/',
  s3:{
    DistributionID:"E205ME6JC5FEIU,EGBYC836VVHS1",
    BucketName: "usae-btwoc-assets-stage",
    FolderPath: "assets/stage/",
    FilePath: "null"
  },
  ClowderConfig: {
    devBaseURL: 'https://syngenta-gate.dataloop.ai/api/v1',
    devDefaultDataset: '65b7af7f249373e014e37b1a',
    devDefaultDatasetReleaseForm: '65b7af9fe68ae7591f1cef28',
    dashboardCrops: ['Corn-field', 'Corn-pop', 'Corn-sweet', 'Soybean', 'Cotton', 'Wheat', 'Peanut', 'Potato', 'Grapes', 'Almond', 'Walnut', 'Rice', 'No-Crop'],
    datasets: [
      { 'Corn-field': '67781d76a33165e4f81d1bab', 'programName': 'ALL', 'UOM': ['Bu/A'] },]
    }
};

export const oktaApp = {
  oidc: {
    clientId: '0oa1xjgr6o60u4TFs0h8',
    issuer: 'https://signin-test.syngenta.com/oauth2/ausqmgapztkTfvQg70h7',
    redirectUri: 'http://localhost:4200/login/callback',
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    testing: {
      disableHttpsCheck: false
    }
  }
};

